'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:flight:getFilter');
}

var _invoke = require('../invoke');

/**
 * 机票筛选
 *
 * TODO：补全参数
 *
 * @memberof flight
 * @static
 * @name getFilter
 * @param {Object} opts
 * @return {Promise}
 * @example
 *  hbnb.flight.getFilters([
 *  ]).then(function(data) {
 *  });
 */
module.exports = function(opts) {
    if (process.env.NODE_ENV !== 'production') {
        debug('opts is %j', opts);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('flight', 'get_filter', {
            options: opts,
            callback: function(data) {
                resolve(data);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/flight/get-filter.js
// module id = 578
// module chunks = 0